import React, { useState, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import Avatar from "@mui/material/Avatar";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import validator from "validator";
import { useUser } from "../../../context/UserContext"; // adjust path

import { useAlert } from "../../../context/AlertContext";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useNavigate } from "react-router-dom";
import InputTest from "./components/InputTest";
import { jwtDecode } from "jwt-decode";

const EditProfile = ({
  openPopup,
  activeClientInformation,
  refresh,
  setActiveClientInformation,
}) => {
  const { showAlert, closeAlert } = useAlert();

  const { user, setUser } = useUser();

  console.log("Current logged user:", user.firstName);

  const initialValues = {
    gender: {
      male: user?.gender === "Male" || false,
      female: user?.gender === "Female" || false,
    },
    birthday: user?.birthday || "",
    email: user?.email || "",
    first_name: user?.first_name || "",
    last_name: user?.last_name || "",
    phone: user?.phone || "",
    address: user?.address || "",
    nickname: user?.nickname || "",
    notes: user?.notes || "",
  };

  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [nickname, setNickname] = useState("");
  const [id, setId] = useState(localStorage.getItem("id"));

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const user = decoded.user || {};

        setGender(user.gender || "");
        setEmail(user.email || "");
        setFirstName(user.first_name || "");
        setLastName(user.last_name || "");
        setPhone(user.phone || "");
        setAddress(user.address || "");

        setNickname(user.nickname || "");
      } catch (err) {
        console.error("Invalid token", err);
      }
    }
  }, []);

  const handleGenderChange = (event) => {
    const { name, checked } = event.target;

    setGender({
      male: name === "male" ? checked : false,
      female: name === "female" ? checked : false,
    });
  };
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const validateNotes = (e) => {
    const notes = e.target.value;
    setNotes(notes);
  };

  const validateNickname = (e) => {
    const nickname = e.target.value;
    setNickname(nickname);
  };
  const validateAddres = (e) => {
    const address = e.target.value;
    setAddress(address);
  };

  const validateEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };
  const validatePhone = (e) => {
    const phone = e.target.value;
    setPhone(phone);
  };

  const validateFirstName = (e) => {
    const firstName = e.target.value;
    setFirstName(firstName);
  };

  const validateLastName = (e) => {
    const lastName = e.target.value;
    setLastName(lastName);
  };
  const getChangedFields = () => {
    const currentValues = {
      gender: gender.male ? "Male" : gender.female ? "Female" : null,
      birthday,
      email,
      first_name: firstName,
      nickname,
      notes,
      last_name: lastName,
      phone,
      address,
    };

    const data = Object.keys(currentValues).reduce((acc, key) => {
      if (key !== "gender" && currentValues[key] !== initialValues[key]) {
        acc[key] = currentValues[key];
      } else if (
        key === "gender" &&
        currentValues[key] !== initialValues.gender
      ) {
        acc[key] = currentValues[key];
      }
      return acc;
    }, {});

    return data;
  };

  const handleBirthdayChange = (event) => {
    setBirthday(event.target.value);
  };

  const onEdit = async (e) => {
    if (firstName === "") {
      showAlert("Nije popunjemo polje za ime", "error");

      return;
    }
    if (gender === "") {
      showAlert("Niste oznacili pol", "error");

      return;
    }

    if (lastName === "") {
      showAlert("Nije popunjemo polje za prezime", "error");

      return;
    }

    try {
      const changedData = getChangedFields();
      if (!changedData.gender) {
        showAlert("Niste oznacili pol", "error");
        return;
      }

      if (changedData.gender === gender) {
        delete changedData.gender;
      }
      if (Object.values(changedData).length === 0) {
        showAlert("Nema promena", "info");
        return;
      }

      const google_token = localStorage.getItem("googleAccessToken");
      changedData.googleToken = google_token;

      const response = await ApiMethods.post(`client/${id}`, changedData);
      console.log(response, "resdadas");

      const updatedClientInformation = {
        ...initialValues,
        ...changedData,
      };

      setUser(updatedClientInformation);

      showAlert("Uspesno ste editovali klijenta", "success");
    } catch (error) {
      showAlert("Doslo je do greske", "error");
      console.error("Error during registration:", error);
    }
  };

  return (
    <div className="centered-modal" style={{ backgroundColor: "white" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 20px",
          borderBottom: "1px solid #EC0707",
          marginBottom: "20px",
          height: "auto",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            height: "auto",
          }}
        >
          <CalendarMonthIcon style={{ color: "#404040" }} />
          <span
            style={{ fontWeight: "700", fontSize: "16px", color: "#404040" }}
          >
            User Details
          </span>
        </div>

        <ArrowCircleLeftIcon
          onClick={handleBackClick}
          style={{ cursor: "pointer", color: "#2F3132", fontSize: "32px" }}
          titleAccess="Go back"
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          className="avatar-container"
          style={{
            height: "auto",
            textAlign: "center",
            display: "flex",
            paddingBottom: "10px",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div style={{ height: "70px" }}>
            <img src="/Generic avatar.png" />
          </div>
          <span
            style={{
              color: "#606060",
              fontSize: "10px",
            }}
          >
            Edit photo
          </span>
        </div>

        <div className="edit-part-input" style={{ backgroundColor: "white" }}>
          <InputTest
            autoFocus
            className="label-input-edit"
            placeholder={"Name"}
            icon={<PersonIcon sx={{ fontSize: "15px" }} />}
            id={"name"}
            type={"text"}
            nameInput={"name"}
            value={firstName}
            onChange={validateFirstName}
          />
          <InputTest
            className="label-input-edit"
            placeholder={"Surname"}
            icon={<PersonAddAlt1Icon sx={{ fontSize: "15px" }} />}
            id={"surname"}
            value={lastName}
            nameInput={"surname"}
            onChange={validateLastName}
          />

          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              padding: "10px",
              height: "45px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span
                style={{
                  color: "#e4322d",
                  fontSize: "16px",
                  fontWeight: "400",

                  height: "auto",
                }}
              >
                Gender
              </span>

              <input
                type="checkbox"
                name="male"
                checked={gender.male}
                onChange={handleGenderChange}
                style={{
                  borderRadius: "50%",
                  width: "30px",
                  fontWeight: "400",

                  height: "30px",
                  cursor: "pointer",
                  appearance: "none",
                  border: "2px solid #0BF",
                  backgroundColor: gender.male ? "#95E3FF" : "e4322d",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "500",
                  color: gender.male ? "white" : "#0BF",
                  textAlign: "center",
                  fontSize: "13px",
                  color: "white",
                }}
                className="gender-checkbox male-checkbox-edit"
                data-label="M"
              />

              <input
                type="checkbox"
                name="female"
                className="gender-checkbox female-checkbox-edit"
                checked={gender.female}
                onChange={handleGenderChange}
                style={{
                  color: "#898a8d",
                  borderRadius: "50%",
                  width: "30px",

                  height: "30px",
                  cursor: "pointer",
                  appearance: "none",
                  border: "2px solid #FB8BD2",
                  backgroundColor: gender.female ? "#FFD6F0" : "e4322d",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  color: gender.female ? "white" : "#FB8BD2",
                  textAlign: "center",
                  fontSize: "13px",
                  fontWeight: "400",
                }}
                data-label="F"
              />
            </div>
          </div>
          <InputTest
            className="label-input-edit"
            placeholder={"Nickname"}
            icon={<PersonAddAlt1Icon sx={{ fontSize: "15px" }} />}
            id={"nickname"}
            value={nickname}
            nameInput={"nickname"}
            onChange={validateNickname}
          />
          <InputTest
            className="label-input-edit"
            placeholder={"Notes"}
            icon={<PersonAddAlt1Icon sx={{ fontSize: "15px" }} />}
            id={"notes"}
            value={notes}
            nameInput={"notes"}
            onChange={validateNotes}
          />

          <InputTest
            className="label-input-edit"
            placeholder={"E-mail"}
            value={email}
            icon={<EmailIcon sx={{ fontSize: "15px" }} />}
            id={"email"}
            type={"email"}
            nameInput={"email"}
            onChange={validateEmail}
          />
          <InputTest
            className="label-input-edit"
            placeholder={"Address"}
            icon={<AddLocationAltIcon sx={{ fontSize: "15px" }} />}
            id={"address"}
            value={address}
            nameInput={"address"}
            onChange={validateAddres}
          />
          <InputTest
            className="label-input-edit"
            icon={<LocalPhoneIcon sx={{ fontSize: "15px" }} />}
            placeholder={"Phone"}
            id={"phone"}
            value={phone}
            type={"phone"}
            nameInput={"phone"}
            onChange={validatePhone}
          />
          <button
            onClick={() => onEdit()}
            className="save-button-add-client-edit"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
